var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.72 16.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#1c3152;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.5px;}.cls-4{fill:#1c3152;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23.72,
    height: 16.77
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.86,7s-4.94,6.72-11,6.72S.81,7,.81,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.59,11.71l-.6,1a.72.72,0,0,0,.24,1,.69.69,0,0,0,.37.1.74.74,0,0,0,.62-.34l.56-.92c-.41-.26-.82-.53-1.19-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.54,13l-.38,1a.74.74,0,0,0,.41.94.8.8,0,0,0,.26.05.71.71,0,0,0,.67-.46l.34-.86A14.12,14.12,0,0,1,6.54,13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.21,8.87c-.29.32-.63.67-1,1l1.1,1a.74.74,0,0,0,.48.18.71.71,0,0,0,.54-.24.73.73,0,0,0-.06-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1.2,8.59.44,9.2a.72.72,0,0,0-.12,1,.71.71,0,0,0,.57.27.73.73,0,0,0,.44-.15l.87-.69c-.39-.38-.72-.73-1-1.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.69,13.89l-.17.84a.72.72,0,0,0,.56.85l.14,0A.73.73,0,0,0,9.93,15l.16-.78a9.25,9.25,0,0,1-1.4-.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2.82,10.24l-.76.86a.72.72,0,0,0,.06,1,.74.74,0,0,0,.48.18.71.71,0,0,0,.54-.24l.77-.87c-.39-.32-.75-.63-1.09-.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.61,10.45c-.34.31-.71.62-1.1.92l.9,1.14a.74.74,0,0,0,.56.27.69.69,0,0,0,.45-.16.73.73,0,0,0,.12-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.86,11.86c-.39.27-.79.54-1.21.79l.61,1.13a.75.75,0,0,0,1,.29.72.72,0,0,0,.29-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.91,13.06a12,12,0,0,1-1.31.6l.33,1a.72.72,0,0,0,.68.49,1,1,0,0,0,.23,0,.72.72,0,0,0,.45-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.35,14.29l.12.82a.73.73,0,0,0,.71.62h.11a.73.73,0,0,0,.61-.82l-.14-1a9.65,9.65,0,0,1-1.41.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.83,14.43a7.54,7.54,0,0,1-.83-.06l0,.77a.72.72,0,0,0,.7.74h0a.72.72,0,0,0,.72-.7l0-.79c-.2,0-.4,0-.61,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close-eye.030f570b87129c9b4ea3135b8a3ca8b3.svg";
export { ForwardRef as ReactComponent };